<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()" [strong]="true" data-cy="betslip-close">X</ion-button>
    </ion-buttons>
    <ion-title class="tw-text-center" data-cy="betslip-title">RUNNER REPLAYS</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="runner-replays-modal-container ion-padding">

  <div *ngFor="let runner of runnerWithReplays; index as z">
    <div class="runner-list">
      <span>{{ runner?.runnerId }}</span>
      <span>{{ runner?.name }}</span>
    </div>
    <div class="table-replays">
      <div class="tw-overflow-auto">
        <table
          *ngIf="runner?.availableReplays.length !== 0"
          class="tw-w-[600px]"
        >
          <thead>
            <tr>
              <th></th>
              <th><span>Track</span></th>
              <th><span>Date</span></th>
              <th><span>Breed</span></th>
              <th><span>Race</span></th>
              <th><span>Distance</span></th>
              <th><span>Surface</span></th>
              <th><span>Purse</span></th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="let replay of runner?.availableReplays; index as i">
              <tr
                *ngIf="i <= 4"
                (click)="getReplayVideo(replay)"
              >
                <td>
                  <ion-icon name="play-circle-outline"></ion-icon>
                </td>
                <td>
                  <span>{{ replay?.track }}</span>
                </td>
                <td>
                  <span>{{ replay?.date | dateFormat: 'MM-DD-YYYY' }}</span>
                </td>
                <td>
                  <span>{{ replay?.breed }}</span>
                </td>
                <td>
                  <span>{{ replay?.race }}</span>
                </td>
                <td>
                  <span>{{ replay?.distance }}</span>
                </td>
                <td>
                  <span>{{ replay?.surface }}</span>
                </td>
                <td>
                  <span>{{ '$' + (replay?.purse | numberWithCommas: 0) }}</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <div *ngIf="runner?.availableReplays.length === 0">
          <p>No Replays to display</p>
        </div>
        <ion-spinner *ngIf="isLoadingReplays" name="dots" slot="end">
        </ion-spinner>
      </div>
    </div>
  </div>

</ion-content>
